///include /assets/js/app/p/sbproduct.js
"use strict"

/**
 * @typedef {SBVPSFreeOS | SBVPSOSProduct} SBVPSAnyOS
 */

class SBVPSOSProduct extends SBNonTransferProduct {
    static get prefix() {
        return "vps_os"
    }
    /**
     *
     * @param {?SProduct} [p]
     */
    constructor(p = null) {
        super(p)
    }
    get codePrefix() {
        return "vps_os"
    }
    get defaultAbstractPaymentType() {
        return "any"
    }
    get groupName() {
        return this.label.replace(/ .*/, "")
    }

    get typeRef() {
        return this.codeComponents[0]
    }

    /**
     * Returns true if a valid rebuild option
     * @param {SBVPSFreeOS | SBVPSOSProduct} other_option
     * @returns {boolean}
     */
    mayRebuildFrom(other_option) {
        if(other_option instanceof SBVPSOSProduct) {
            const other_pricing_signatures = {}
            other_option.pricing.forEach(
                p => other_pricing_signatures[JSON.stringify(p)] = true
            )
            return this.pricing.some(
                p => other_pricing_signatures[JSON.stringify(p)]
            )
        } else {
            return false
        }
    }

    /**
     *
     * @param {string | number} app_code
     * @returns {boolean}
     */
    supportsApp(app_code) {
        return this.typeRef == "rhel6" // Platform workaround
    }
}

class SBVPSFreeOS {
    /**
     *
     * @param {string} type_ref
     * @param {string} label
     */
    constructor(type_ref, label) {
        this.typeRef = type_ref
        this.label = label
    }
    get groupName() {
        return this.label.replace(/ .*/, "")
    }

    /**
     * The lowest price offered for the standard action, for "from [price] per
     * [period]"
     *
     * @returns {?SBProductPricing}
     */
    get lowestPrice() {
        return new SBProductPricing(
            {
                action: null,
                isManaged: false,
                paymentType: "any",
                periodMonths: 1,
                price: 0
            },
            false
        )
    }

    /**
     * Returns the price for the given details
     * @param {string} payment_type
     * @param {number} months
     * @returns {?number}
     */
    initialPriceFor(payment_type, months) {
        return 0
    }

    /**
     * Returns the price for the given details
     * @param {string} general_payment_type
     * @param {number} months
     * @returns {?number}
     */
    initialPriceForGeneral(general_payment_type, months) {
        return 0
    }

    /**
     * Returns true if a valid rebuild option
     * @param {SBVPSFreeOS | SBVPSOSProduct} other_option
     * @returns {boolean}
     */
    mayRebuildFrom(other_option) {
        return (other_option instanceof SBVPSFreeOS)
    }

    /**
     * Returns true if the supplied months value is supported
     *
     * @param {number} months
     * @returns {boolean}
     */
    pricingSupportsMonths(months) {
        return true
    }

    /**
     * Returns true if the supplied real payment type value is supported
     *
     * @param {string} payment_type
     * @returns {boolean}
     */
    pricingSupportsRealType(payment_type) {
        return true
    }

    /**
     *
     * @param {string | number} app_code
     * @returns {boolean}
     */
    supportsApp(app_code) {
        return this.typeRef == "rhel6" // Platform workaround
    }
}

SBProduct.register([
    SBVPSOSProduct
])
